// Next Diamonds: clickable review stars (2026-09-22).
// Product page: the stars under the price scroll to the Loox reviews
// section (#looxReviews). Collection cards: the stars open Loox's own
// reviews pop-up for that product (LOOX.openHCFloater) without leaving
// the page; if Loox has not loaded, the link falls back to the product
// page's reviews section.
(function () {
  'use strict';
  if (window.__ndReviewLinksBound) return;
  window.__ndReviewLinksBound = true;

  function scrollToReviews(smooth) {
    var target = document.getElementById('looxReviews');
    if (!target) return false;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a.nd-rating-link') : null;
    if (!link) return;

    var productId = link.getAttribute('data-product-id');
    if (productId) {
      // Collection / search / featured cards: open the pop-up in place.
      if (window.LOOX && typeof window.LOOX.openHCFloater === 'function') {
        event.preventDefault();
        try {
          window.LOOX.openHCFloater(productId);
          return;
        } catch (err) {
          window.location.href = link.href;
        }
      }
      return; // Loox not ready: normal navigation to the product's reviews.
    }

    // Product page: smooth scroll to the reviews widget.
    if ((link.getAttribute('href') || '') === '#looxReviews' && scrollToReviews(true)) {
      event.preventDefault();
      try { history.replaceState(null, '', '#looxReviews'); } catch (err) {}
    }
  });

  // Arriving with #looxReviews (fallback path): the widget loads late, re-aim twice.
  if (window.location.hash === '#looxReviews') {
    setTimeout(function () { scrollToReviews(false); }, 1200);
    setTimeout(function () { scrollToReviews(false); }, 3000);
  }
})();
